"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var HeadquarterFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_HeadquarterFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.638 9.44c-.113-.413-.17-.92-.17-1.52s.057-1.103.17-1.51c.113-.413.287-.727.52-.94.24-.213.537-.32.89-.32.527 0 .917.237 1.17.71.253.467.38 1.153.38 2.06 0 .607-.057 1.117-.17 1.53-.113.413-.287.723-.52.93-.227.207-.517.31-.87.31a1.24 1.24 0 0 1-.87-.32c-.233-.213-.41-.523-.53-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.436 2.184C0 3.04 0 4.16 0 6.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C3.04 16 4.16 16 6.4 16h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C16 12.96 16 11.84 16 9.6V6.4c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 13.816.436C12.96 0 11.84 0 9.6 0H6.4C4.16 0 3.04 0 2.184.436A4 4 0 0 0 .436 2.184ZM13.498 9.49c.113-.46.17-.983.17-1.57 0-.787-.1-1.453-.3-2-.2-.547-.493-.96-.88-1.24-.387-.287-.867-.43-1.44-.43-.587 0-1.077.143-1.47.43-.393.28-.687.693-.88 1.24-.193.54-.29 1.203-.29 1.99 0 .52.05 1.003.15 1.45.1.447.253.837.46 1.17.207.333.473.597.8.79.327.187.72.28 1.18.28a.462.462 0 0 0 .09-.01h.09l1.02 1.61h1.26l-1.3-1.84c.333-.16.61-.397.83-.71.227-.313.397-.7.51-1.16ZM6.084 11.5h1.03V4.36h-1.03v2.97h-2.47V4.36h-1.02v7.14h1.02V8.23h2.47v3.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_HeadquarterFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = HeadquarterFill;
exports["default"] = _default;